import React from 'react';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';

import BillCard from './BillCard';

import { useSingleBillStatementQuery } from 'apollo/queries/autogenerate/hooks';
import { BillStatement } from 'apollo/queries/autogenerate/schemas';

type Props = {
  billId: string;
  style?: StyleProp<ViewStyle>;
};

const BillAutoDebitDetails = (props: Props) => {
  const { data } = useSingleBillStatementQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-only',
    variables: {
      id: props.billId,
    },
  });

  if (!data) {
    return null;
  }

  return (
    <View style={[style.root, props.style]}>
      <BillCard
        bill={data.billStatement as BillStatement}
        showTitle={false}
        showPaymentMethod={false}
        showPayButton={false}
        id="bill-autodebit-detail-card"
        style={style.billCard}
      />
      <Text style={[style.text, style.textBold, style.textTitle]}>
        引き落とし日の前日までにご入金ください。
      </Text>
      <Text style={style.text}>
        ※ 引き落としに失敗した場合はコンビニ・銀行払いとなります。
      </Text>
      <Text style={style.text}>
        ※
        引き落とし日の3営業日以降については、MyPaidyにて引き落とし状況の確認が可能です
      </Text>
      <Text style={style.text}>
        ※
        未払いの請求がある場合、引き落とされた金額は古い請求分から順に割り当てられます。
      </Text>
      <Text style={style.text}>
        ※
        口座振替でお支払いいただく場合、毎月1日に請求金額が確定された後に発生したキャンセル分の金額を差し引くことができません。
      </Text>
      <Text style={style.text}>
        そのため口座引落し金額と請求金額が異なる場合がございます。キャンセル分の金額は翌月の請求より差し引かれますので予めご了承ください。
      </Text>
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    backgroundColor: '#F6F8FA',
    padding: 24,
  },
  billCard: {
    marginBottom: 24,
    marginTop: -24,
    marginHorizontal: -24,
  },
  text: {
    color: '#586065',
    fontSize: 12,
    marginBottom: 16,
  },
  textBold: {
    fontWeight: 'bold',
  },
  textTitle: {
    color: '#607D8B',
  },
});

export default BillAutoDebitDetails;
